<template>
  <button class="btn btn-primary btn-lg btn-block filter-reset"
      @click.prevent="clearFilters()"
  >
    Reset Filters
  </button>
</template>

<script>
export default {
  props: {
    callback: {
      type: Function,
      required: true
    },
  },

  methods: {
    clearFilters(event) {
      this.callback()
    },
  }
}
</script>
